import { render, staticRenderFns } from "./accountLayout.vue?vue&type=template&id=f72e359c&scoped=true&"
import script from "./accountLayout.vue?vue&type=script&lang=ts&"
export * from "./accountLayout.vue?vue&type=script&lang=ts&"
import style0 from "./accountLayout.vue?vue&type=style&index=0&id=f72e359c&lang=scss&scoped=true&"
import style1 from "./accountLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72e359c",
  null
  
)

export default component.exports